import React, { useEffect, useState } from "react";
import Dashboard from "../../dashboard/Dashboard";
import Button from "../../../components/buttons/Button";
import "../../../components/generalComponents.scss";
import style from "../../reviews/review.module.scss";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faArrowLeftLong } from "@fortawesome/free-solid-svg-icons";
import { useLocation, useNavigate } from "react-router-dom";
import {
  fetchReviewsByStatus,
  listLanguageSpoken,
} from "../../../services/review.service";
import { LanguageSpoken, LanguageSpokenResponse } from "../types";
import formatDate from "../../../utils/date.formater";
import showToast from "../../../utils/show.toast";
import { LanguageReviewType } from "../../../utils/constants";

interface ISpokenLanguage {
  isLoading: boolean;
  languages: LanguageSpoken[];
}

function useQuery() {
  return new URLSearchParams(useLocation().search);
}

export default function LanguageToSpeakTable() {
  const navigate = useNavigate();
  const query = useQuery();
  const status = query.get("status");

  const [languagesSpoken, setLanguagesSpoken] = useState<ISpokenLanguage>({
    isLoading: true,
    languages: [],
  });

  const sortedRequests = [...languagesSpoken.languages].sort(
    (a, b) => a.id - b.id
  );

  const fetchLanguageSpoken = async () => {
    try {
      const endpoint = `teachers/language-update?category=${LanguageReviewType.SPOKEN}&status=${status}`;
      const response = await fetchReviewsByStatus<LanguageSpokenResponse>(
        endpoint
      );

      if (response.status === "success") {
        setLanguagesSpoken({ isLoading: false, languages: response.result });
      } else {
        showToast(response.message || "Failed to fetch languages", false);
      }
    } catch (err: any) {
      showToast(err?.message || "An error occurred", false);
    }
  };

  useEffect(() => {
    fetchLanguageSpoken();
  }, []);

  const handleBackClick = () => {
    navigate(-1);
  };
  return (
    <Dashboard pageTitle="Language Spoken">
      <div className={style.languagePage}>
        {/* Total Students Count */}
        <div className={style.counterCard}>
          <div className={style.titleTwrapper}>
            <FontAwesomeIcon
              icon={faArrowLeftLong}
              onClick={handleBackClick}
              className={style.backIcon}
            />
            <h2>Language Spoken</h2>
          </div>
        </div>

        {/* Language to Teach Table */}
        <div className={style.pageTable}>
          {languagesSpoken.isLoading ? (
            <p
              className={style.textStyle}
              style={{ marginTop: "2px", marginBottom: "3px" }}
            >
              Loading Requests...
            </p>
          ) : (
            <table>
              <>
                <thead>
                  <tr>
                    {/* <th>ID</th> */}
                    <th>Email</th>
                    <th>Request Date</th>
                  </tr>
                </thead>
                <tbody style={{ cursor: "pointer" }}>
                  {sortedRequests.map((request) => (
                    <tr
                      key={request.id}
                      onClick={() =>
                        (window.location.href = `/review/language-spoken/${request.id}/details?status=${status}`)
                      }
                    >
                      {/* <td>{request.id}</td> */}
                      <td>{request.teacher.email}</td>
                      <td>{formatDate(request.requestedAt) ?? null}</td>
                    </tr>
                  ))}
                </tbody>
              </>
            </table>
          )}
        </div>
      </div>
    </Dashboard>
  );
}
